module.exports = __webpack_public_path__ + "static/Grenette-SemiBold-Pro-399afee67f851d8330a85d1eec3d845a.woff2";